/* LUXURIA – Fahrzeug-Check
   Marke → Baureihe → passende Nachrüstungen aus dem echten Sortiment.
   Datenquelle: /collections/all?view=lux-finder (kompaktes JSON, einmal pro Sitzung geladen). */
(function () {
  'use strict';

  // Kategorie-Erkennung anhand des Produkttitels (Reihenfolge = Anzeige-Reihenfolge)
  var CATEGORIES = [
    { key: 'ambient', label: 'Ambientebeleuchtung', re: /ambientebeleuchtung|hochtöner|lüftungsdüsen/i },
    { key: 'camera360', label: '360° Kamera', re: /360/ },
    { key: 'camera', label: 'Rückfahrkamera', re: /rückfahrkamera/i },
    { key: 'carplay', label: 'CarPlay & Android Auto', re: /carplay|smartphone interface|android auto/i },
    { key: 'assist', label: 'Assistenzsysteme', re: /spurwechsel|totwinkel|side assist|acc-nachrüstung|abstandsregel/i },
    { key: 'keyless', label: 'Keyless Entry', re: /keyless/i },
    { key: 'carbon', label: 'Carbon Interieur', re: /carbon/i },
    { key: 'stars', label: 'Sternenhimmel', re: /sternenhimmel/i },
    { key: 'exhaust', label: 'Abgasanlage', re: /abgas/i }
  ];
  var OTHER = { key: 'other', label: 'Weitere' };

  function categoryOf(title) {
    for (var i = 0; i < CATEGORIES.length; i++) {
      if (CATEGORIES[i].re.test(title)) return CATEGORIES[i];
    }
    return OTHER;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function escapeRe(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  var tokenCache = {};
  function tokenRe(token) {
    if (!tokenCache[token]) {
      var boundary = '[^0-9A-Za-zÀ-ÖØ-öø-ÿ]';
      tokenCache[token] = new RegExp('(^|' + boundary + ')' + escapeRe(token) + '(?=$|' + boundary + ')', 'i');
    }
    return tokenCache[token];
  }

  // "A4+B9,A5" → (A4 UND B9) ODER A5
  function matches(title, spec) {
    if (!spec) return true;
    return spec.split(',').some(function (alt) {
      var tokens = alt.split('+').map(function (t) { return t.trim(); }).filter(Boolean);
      return tokens.length > 0 && tokens.every(function (t) { return tokenRe(t).test(title); });
    });
  }

  // Fahrzeug ist bereits gewählt → Titel auf die eigentliche Nachrüstung kürzen
  function cleanTitle(title) {
    var t = title;
    if (t.indexOf(' für ') > 0) t = t.split(' für ')[0];
    t = t.split(' | ')[0].split(' – ')[0];
    return t
      .replace(/\s*\(Nachrüstung\)\s*/gi, ' ')
      .replace(/\s*inkl\.\s*Einbau\s*$/i, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  // Daten kommen aus dem gemeinsamen Lader (assets/lux-data.js) – inkl. Zusatz-Collections und Sitzungs-Cache
  function loadProducts(endpoint, extraHandles) {
    if (!window.LuxData) return Promise.reject(new Error('LuxData fehlt'));
    return window.LuxData.load(endpoint, extraHandles);
  }

  function Finder(root) {
    this.root = root;
    this.endpoint = root.getAttribute('data-endpoint');
    this.extraCollections = (root.getAttribute('data-extra-collections') || '')
      .split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    this.searchUrl = root.getAttribute('data-search-url') || '/search';
    this.whatsapp = root.getAttribute('data-whatsapp') || '';
    var configEl = root.querySelector('[data-lux-finder-config]');
    try {
      this.config = JSON.parse(configEl.textContent);
    } catch (e) {
      this.config = { brands: [] };
    }
    this.products = null;
    this.loading = null;
    this.brand = null;
    this.series = null;
    this.category = 'all';

    this.stepEls = {};
    var self = this;
    root.querySelectorAll('[data-step]').forEach(function (el) {
      self.stepEls[el.getAttribute('data-step')] = el;
    });
    this.seriesEl = root.querySelector('[data-series]');
    this.resultsEl = root.querySelector('[data-results]');
    this.filtersEl = root.querySelector('[data-filters]');
    this.liveEl = root.querySelector('[data-live]');

    root.classList.add('is-enhanced');
    this.bind();
    this.initQuick();
    this.observe();
    this.fromHash();
    window.addEventListener('hashchange', this.fromHash.bind(this));
    this.bindDeepLinks();
  }

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HEADER_OFFSET = 88;

  // Scrollt ein Element mit Abstand zum (beim Hochscrollen eingeblendeten) Header in den Blick
  function scrollToEl(el, smooth) {
    if (!el) return;
    var top = Math.max(0, el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET);
    if (smooth && !reduceMotion) {
      window.scrollTo({ top: top, behavior: 'smooth' });
      return;
    }
    // Das Basistheme setzt html { scroll-behavior: smooth } – dann wäre auch behavior 'auto' animiert.
    // Für den sofortigen Sprung (Seitenaufruf mit Deep-Link) kurz ausschalten.
    var html = document.documentElement;
    var prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, top);
    html.style.scrollBehavior = prev;
  }

  // Links auf /#fahrzeug-check/<marke> auf derselben Seite direkt verarbeiten –
  // auch beim erneuten Klick auf denselben Link (dann feuert kein hashchange)
  Finder.prototype.bindDeepLinks = function () {
    var self = this;
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href*="#fahrzeug-check"]');
      if (!link || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      var url;
      try { url = new URL(link.getAttribute('href'), window.location.href); } catch (err) { return; }
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
      e.preventDefault();
      if (window.location.hash !== url.hash) history.pushState(null, '', url.hash);
      self.fromHash(true);
    });
  };

  function slug(value) {
    var v = String(value || '');
    if (v.normalize) v = v.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return v.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  // Deep-Link aus dem Menü: /#fahrzeug-check/<marke> → Marke vorauswählen (nur Auswahl, keine Datenänderung)
  Finder.prototype.fromHash = function (fromClick) {
    var hash = window.location.hash || '';
    if (hash.indexOf('#fahrzeug-check') !== 0) return;
    var m = /^#fahrzeug-check\/(.+)$/.exec(hash);
    if (m) {
      var want;
      try { want = slug(decodeURIComponent(m[1])); } catch (e) { want = slug(m[1]); }
      var brands = this.config.brands || [];
      for (var i = 0; i < brands.length; i++) {
        if (slug(brands[i].name) === want) {
          this.selectBrand(i, true);
          break;
        }
      }
    }
    var root = this.root;
    scrollToEl(root, fromClick === true);
    // Beim Seitenaufruf verschieben nachladende Bilder/Sections darüber den Finder – nach dem Laden erneut ausrichten
    if (fromClick !== true) {
      var settled = window.scrollY;
      var realign = function () {
        if (Math.abs(window.scrollY - settled) > 60) return; // Nutzer hat inzwischen selbst gescrollt
        scrollToEl(root, false);
      };
      if (document.readyState === 'complete') setTimeout(realign, 150);
      else window.addEventListener('load', function () { setTimeout(realign, 50); }, { once: true });
    }
  };

  // Schnellwahl: nur Einträge anzeigen, die sich eindeutig einer hinterlegten Baureihe zuordnen lassen
  Finder.prototype.resolveQuick = function (btn) {
    var brandName = (btn.getAttribute('data-quick-brand') || '').trim().toLowerCase();
    var model = (btn.getAttribute('data-quick-model') || '').trim().toLowerCase();
    var code = (btn.getAttribute('data-quick-code') || '').trim().toLowerCase();
    var brands = this.config.brands;
    for (var b = 0; b < brands.length; b++) {
      if (brands[b].name.trim().toLowerCase() !== brandName) continue;
      for (var s = 0; s < brands[b].series.length; s++) {
        var series = brands[b].series[s];
        if (series.model.trim().toLowerCase() === model && series.code.trim().toLowerCase() === code) {
          return { brand: b, series: s };
        }
      }
    }
    return null;
  };

  Finder.prototype.initQuick = function () {
    var self = this;
    var wrap = this.root.querySelector('[data-quick-wrap]');
    if (!wrap) return;
    var any = false;
    wrap.querySelectorAll('[data-quick-brand]').forEach(function (btn) {
      var hit = self.resolveQuick(btn);
      if (hit) {
        btn.setAttribute('data-quick-target', hit.brand + ':' + hit.series);
        any = true;
      } else {
        btn.closest('li').hidden = true;
      }
    });
    wrap.hidden = !any;
  };

  Finder.prototype.observe = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) {
      this.ensureData();
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) {
        io.disconnect();
        self.ensureData();
      }
    }, { rootMargin: '400px 0px' });
    io.observe(this.root);
  };

  Finder.prototype.ensureData = function () {
    var self = this;
    if (this.products) return Promise.resolve(this.products);
    if (!this.loading) {
      this.root.classList.add('is-loading');
      this.loading = loadProducts(this.endpoint, this.extraCollections)
        .then(function (products) {
          self.products = products;
          self.root.classList.remove('is-loading');
          self.updateBrandMeta();
          return products;
        })
        .catch(function () {
          self.root.classList.remove('is-loading');
          self.root.classList.add('is-offline');
          self.products = null;
          self.loading = null;
          return null;
        });
    }
    return this.loading;
  };

  Finder.prototype.productsFor = function (brand, series) {
    if (!this.products) return [];
    return this.products.filter(function (p) {
      return matches(p.t, brand.match) && matches(p.t, series.match);
    });
  };

  Finder.prototype.updateBrandMeta = function () {
    var self = this;
    this.root.querySelectorAll('[data-brand-index]').forEach(function (el) {
      var brand = self.config.brands[+el.getAttribute('data-brand-index')];
      if (!brand) return;
      var seen = {};
      var seriesWithHits = 0;
      brand.series.forEach(function (s) {
        var hits = self.productsFor(brand, s);
        if (hits.length) seriesWithHits++;
        hits.forEach(function (p) { seen[p.u] = true; });
      });
      var total = Object.keys(seen).length;
      var meta = el.querySelector('[data-brand-meta]');
      if (meta && total) {
        meta.textContent = seriesWithHits + ' Baureihen · ' + total + ' Nachrüstungen';
      }
    });
  };

  Finder.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (event) {
      var brandLink = event.target.closest('[data-brand-index]');
      if (brandLink) {
        event.preventDefault();
        self.selectBrand(+brandLink.getAttribute('data-brand-index'));
        return;
      }
      var quick = event.target.closest('[data-quick-target]');
      if (quick) {
        var parts = quick.getAttribute('data-quick-target').split(':');
        self.brand = self.config.brands[+parts[0]];
        self.root.querySelector('[data-step-title="2"]').textContent = self.brand.name + ' – wähle deine Baureihe';
        self.renderSeries();
        self.selectSeries(+parts[1]);
        return;
      }
      var seriesBtn = event.target.closest('[data-series-index]');
      if (seriesBtn) {
        self.selectSeries(+seriesBtn.getAttribute('data-series-index'));
        return;
      }
      var back = event.target.closest('[data-back]');
      if (back) {
        self.go(+back.getAttribute('data-back'), true);
        return;
      }
      var filter = event.target.closest('[data-filter]');
      if (filter) {
        self.category = filter.getAttribute('data-filter');
        self.renderResults();
      }
    });
  };

  Finder.prototype.go = function (step, focus, noScroll) {
    var self = this;
    Object.keys(this.stepEls).forEach(function (key) {
      self.stepEls[key].hidden = +key !== step;
    });
    this.root.querySelectorAll('[data-progress]').forEach(function (el) {
      var n = +el.getAttribute('data-progress');
      el.classList.toggle('is-active', n === step);
      el.classList.toggle('is-done', n < step);
      if (n === step) el.setAttribute('aria-current', 'step');
      else el.removeAttribute('aria-current');
    });
    var target = step === 1
      ? this.root.querySelector('[data-brand-index]')
      : this.root.querySelector('[data-step-title="' + step + '"]');
    if (focus && target) target.focus({ preventScroll: true });
    if (noScroll) return;
    // Überschrift des neuen Schritts in den Blick holen (mit Abstand zum Header), wenn sie außer Sicht ist
    var anchor = step === 1 ? this.root.querySelector('.lux-finder__panel') : target;
    if (anchor) {
      var top = anchor.getBoundingClientRect().top;
      if (top < HEADER_OFFSET - 8 || top > window.innerHeight * 0.55) scrollToEl(anchor, true);
    }
  };

  Finder.prototype.selectBrand = function (index, noScroll) {
    var self = this;
    this.brand = this.config.brands[index];
    if (!this.brand) return;
    this.root.querySelector('[data-step-title="2"]').textContent = this.brand.name + ' – wähle deine Baureihe';
    this.renderSeries();
    this.go(2, true, noScroll);
    this.ensureData().then(function () { self.renderSeries(); });
  };

  Finder.prototype.renderSeries = function () {
    var self = this;
    var brand = this.brand;
    var html = '';
    brand.series.forEach(function (s, i) {
      var count = self.products ? self.productsFor(brand, s).length : null;
      if (count === 0) return;
      html += '<li><button type="button" class="lux-fchip" data-series-index="' + i + '">' +
        '<span class="lux-fchip__model">' + escapeHtml(s.model) + '</span>' +
        '<span class="lux-fchip__code">' + escapeHtml(s.code) + '</span>' +
        (count !== null ? '<span class="lux-fchip__count">' + count + '</span>' : '') +
        '</button></li>';
    });
    if (!html) {
      html = '<li class="lux-finder__empty">Für diese Marke sind aktuell keine Baureihen hinterlegt.</li>';
    }
    this.seriesEl.innerHTML = html;
  };

  Finder.prototype.selectSeries = function (index) {
    var self = this;
    this.series = this.brand.series[index];
    this.category = 'all';
    this.onlyCategory = null;
    var vehicle = this.vehicleLabel();
    this.root.querySelector('[data-step-title="3"]').textContent = vehicle;

    this.updateWhatsApp();
    var all = this.root.querySelector('[data-search-all]');
    if (all) {
      var firstAlt = (this.series.match || '').split(',')[0].split('+').join(' ');
      var brandTerm = (this.brand.match || '').split(',')[0];
      all.href = this.searchUrl + '?type=product&q=' + encodeURIComponent((brandTerm + ' ' + firstAlt).trim());
    }

    this.resultsEl.innerHTML = '<li class="lux-finder__empty">Nachrüstungen werden geladen …</li>';
    this.filtersEl.innerHTML = '';
    this.go(3, true);
    this.ensureData().then(function () { self.renderResults(); });
  };

  Finder.prototype.vehicleLabel = function () {
    return [this.brand.name, this.series.model, this.series.code].filter(Boolean).join(' ');
  };

  // WhatsApp-Nachricht mit Fahrzeug und gewählter Kategorie vorausfüllen (bei jedem Filterwechsel neu)
  Finder.prototype.updateWhatsApp = function () {
    var wa = this.root.querySelector('[data-whatsapp-fin]');
    if (!wa || !this.whatsapp || !this.series) return;
    var key = this.category === 'all' && this.onlyCategory ? this.onlyCategory : this.category;
    var cat = CATEGORIES.concat([OTHER]).filter(function (c) { return c.key === key; })[0];
    var wish = !cat ? 'Nachrüstung (Kategorie noch offen)'
      : cat.key === 'other' ? 'Weitere Nachrüstung'
      : cat.label;
    var text = [
      'Hallo LUXURIA,',
      'ich interessiere mich für folgende Nachrüstung:\n' + this.vehicleLabel() + ' – ' + wish,
      'Angefragt über den Fahrzeug-Check.',
      'Bitte prüft kurz die Kompatibilität.',
      'Meine FIN:\n'
    ].join('\n\n');
    wa.href = this.whatsapp + (this.whatsapp.indexOf('?') === -1 ? '?' : '&') + 'text=' + encodeURIComponent(text);
  };

  Finder.prototype.renderResults = function () {
    var self = this;
    if (!this.products) {
      this.resultsEl.innerHTML = '<li class="lux-finder__empty">Die Nachrüstungen konnten gerade nicht geladen werden. ' +
        'Sende uns einfach deine FIN – wir prüfen, was möglich ist.</li>';
      return;
    }
    var hits = this.productsFor(this.brand, this.series).map(function (p) {
      return { p: p, cat: categoryOf(p.t) };
    });
    var order = CATEGORIES.concat([OTHER]).map(function (c) { return c.key; });
    hits.sort(function (a, b) {
      return order.indexOf(a.cat.key) - order.indexOf(b.cat.key) || a.p.t.localeCompare(b.p.t, 'de');
    });

    // Filter-Chips nur für vorhandene Kategorien
    var counts = {};
    hits.forEach(function (h) { counts[h.cat.key] = (counts[h.cat.key] || 0) + 1; });
    var present = CATEGORIES.concat([OTHER]).filter(function (c) { return counts[c.key]; });
    if (this.category !== 'all' && !counts[this.category]) this.category = 'all';

    var filters = '';
    if (present.length > 1) {
      filters += this.filterButton('all', 'Alle', hits.length);
      present.forEach(function (c) { filters += self.filterButton(c.key, c.label, counts[c.key]); });
    }
    this.filtersEl.innerHTML = filters;
    // Nur eine Kategorie vorhanden → sie ist auch ohne Filterklick eindeutig
    this.onlyCategory = present.length === 1 ? present[0].key : null;
    this.updateWhatsApp();

    var visible = hits.filter(function (h) { return self.category === 'all' || h.cat.key === self.category; });
    var html = '';
    visible.forEach(function (h) {
      var p = h.p;
      var title = cleanTitle(p.t);
      var badges = '';
      // Preisregel: nie aus dem Titel ableiten – nur explizit freigegebene Produkte (Tag "preis-inkl-einbau")
      if (p.e === true) badges += '<span class="lux-fres__badge">Inkl. Einbau</span>';
      if (/remote|fernzugriff/i.test(p.t)) badges += '<span class="lux-fres__badge">Remote</span>';
      html += '<li><a class="lux-fres" href="' + escapeHtml(p.u) + '">' +
        '<span class="lux-fres__img">' +
          (p.i ? '<img src="' + escapeHtml(p.i) + '" alt="" loading="lazy" decoding="async" width="240" height="240">' : '<span class="lux-fres__noimg" aria-hidden="true"></span>') +
        '</span>' +
        '<span class="lux-fres__body">' +
          (title.toLowerCase() !== h.cat.label.toLowerCase()
            ? '<span class="lux-fres__cat">' + escapeHtml(h.cat.label) + '</span>'
            : '') +
          '<span class="lux-fres__title">' + escapeHtml(title) + '</span>' +
          '<span class="lux-fres__foot">' +
            '<span class="lux-fres__price">' + (p.f ? '<small>ab</small> ' : '') + escapeHtml(p.p) + (p.r ? ' <small>unverbindlicher Richtpreis</small>' : '') + '</span>' +
            badges +
          '</span>' +
        '</span>' +
      '</a></li>';
    });
    if (!html) {
      html = '<li class="lux-finder__empty">Für diese Baureihe ist aktuell nichts im Shop hinterlegt. ' +
        'Sende uns deine FIN – oft ist trotzdem eine Nachrüstung möglich.</li>';
    }
    this.resultsEl.innerHTML = html;

    var title3 = this.root.querySelector('[data-step-title="3"]');
    title3.innerHTML = escapeHtml(this.vehicleLabel()) +
      ' <span class="lux-finder__count">' + hits.length + (hits.length === 1 ? ' Nachrüstung' : ' Nachrüstungen') + '</span>';
    if (this.liveEl) {
      this.liveEl.textContent = hits.length + ' passende Nachrüstungen für ' + this.vehicleLabel() + ' gefunden.';
    }
  };

  Finder.prototype.filterButton = function (key, label, count) {
    var active = this.category === key;
    return '<button type="button" class="lux-ffilter' + (active ? ' is-active' : '') + '" data-filter="' + key + '" aria-pressed="' + active + '">' +
      escapeHtml(label) + ' <span>' + count + '</span></button>';
  };

  function init() {
    document.querySelectorAll('[data-lux-finder]').forEach(function (root) {
      if (!root.__luxFinder) root.__luxFinder = new Finder(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme-Editor: Section neu geladen
  document.addEventListener('shopify:section:load', init);
})();
